import { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'

type OrientationLockType =
  | 'any'
  | 'natural'
  | 'landscape'
  | 'portrait'
  | 'portrait-primary'
  | 'portrait-secondary'
  | 'landscape-primary'
  | 'landscape-secondary'

export interface ScreenOrientation extends globalThis.ScreenOrientation {
  lock(orientation: OrientationLockType): Promise<void>
}

export const useOrientationLock = (orientationLockType: OrientationLockType, active = true): void => {
  const enabled =
    active &&
    'orientation' in window.screen &&
    'lock' in window.screen.orientation &&
    'unlock' in window.screen.orientation

  useEffect(() => {
    if (enabled) {
      const orientation: ScreenOrientation = window.screen.orientation as ScreenOrientation
      orientation.lock(orientationLockType).catch((e) => {
        datadogRum.addAction('orientation-lock', { message: `Failed to lock: ${e.message}` })
      })

      return () => {
        window.screen.orientation.unlock()
      }
    }

    return () => {}
  }, [orientationLockType, enabled])
}
